export const AgentHotelBookingData = [
  {
    key: "1",
    id: "#HB-1245",
    hotelName: "Hotel Athenee",
    location: "Barcelona",
    bookedBy: "Lynwood Dickens",
    bookedLocation: "Texas",
    room: "Suite Room",
    guest: "2 Adults, 1 Child",
    days: "4 Days, 3 Nights",
    pricing: "$11,569",
    bookedOn: "15 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "2",
    id: "#HB-3215",
    hotelName: "The Luxe Haven",
    location: "London",
    bookedBy: "James Osborne",
    bookedLocation: "California",
    room: "Queen Room",
    guest: "2 Adults, 2 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,745",
    bookedOn: "20 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "3",
    id: "#HB-4581",
    hotelName: "The Urban Retreat",
    location: "The Urban Retreat",
    bookedBy: "Steve Grieve",
    bookedLocation: "Newyork",
    room: "Single Room",
    guest: "2 Adults, 1 Child",
    days: "2 Days, 1 Night",
    pricing: "$8,160",
    bookedOn: "04 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "4",
    id: "#HB-6545",
    hotelName: "The Grand Horizon",
    location: "Manchester",
    bookedBy: "Alene Downing",
    bookedLocation: "Florida",
    room: "Florida",
    guest: "3 Adults, 2 Child",
    days: "5 Days, 4 Nights",
    pricing: "$14,840",
    bookedOn: "17 Jun 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "5",
    id: "#HB-3256",
    hotelName: "Hotel Serene Valley",
    location: "Chelsea",
    bookedBy: "Carol Gardner",
    bookedLocation: "Georgia",
    room: "City View",
    guest: "2 Adults, 2 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,450",
    bookedOn: "25 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "6",
    id: "#HB-3654",
    hotelName: "Hotel Evergreen",
    location: "Las Vegas",
    bookedBy: "Enrique Archer",
    bookedLocation: "Las Vegas",
    room: "Suite Room",
    guest: "2 Adults, 1 Child",
    days: "4 Days, 3 Nights",
    pricing: "$12,600",
    bookedOn: "02 Jul 2025",
    status: "Cancelled",
    action: "cancelled",
  },
  {
    key: "7",
    id: "#HB-1458",
    hotelName: "Stardust Hotel",
    location: "Salford",
    bookedBy: "Weston Carrasco",
    bookedLocation: "Texas",
    room: "Suite Room",
    guest: "2 Adults, 2 Child",
    days: "2 Days, 1 Night",
    pricing: "$9,380",
    bookedOn: "12 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "8",
    id: "#HB-6589",
    hotelName: "Hotel Plaza",
    location: "Newyork",
    bookedBy: "Bonnie Coleman",
    bookedLocation: "California",
    room: "Single Room",
    guest: "1 Adult, 1 Child",
    days: "3 Days, 2 Nights",
    pricing: "$10,400",
    bookedOn: "26 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "9",
    id: "#HB-2315",
    hotelName: "Hotel Skyline Vista",
    location: "Cambridge",
    bookedBy: "Aurora Conklin",
    bookedLocation: "Georgia",
    room: "Queen Room",
    guest: "2 Adults, 1 Child",
    days: "4 Days, 3 Nights",
    pricing: "$12,810",
    bookedOn: "10 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "10",
    id: "#HB-5414",
    hotelName: "Hotel Aurora Bliss",
    location: "Bristol",
    bookedBy: "Robin Banks",
    bookedLocation: "Las Vegas",
    room: "Suite Room",
    guest: "2 Adults, 1 Child",
    days: "5 Days, 4 Nights",
    pricing: "$15,450",
    bookedOn: "22 Aug 2025",
    status: "Completed",
    action: "completed",
  },


];
